import { useEffect, useState } from 'react';
import { Form, Button, Modal, Toast, ToastContainer, Alert } from 'react-bootstrap';
import { Pencil, Plus, Trash } from 'react-bootstrap-icons'; 
import { useMemo } from 'react';
import DataTable from 'react-data-table-component';
import api from '../api';

const Servicios = () => {
  const userRole = localStorage.getItem('role');
  const idSala = parseInt(localStorage.getItem('id_sala'), 10);
  const maxServicios = parseInt(localStorage.getItem('numservicios'), 10);
  const [servicios, setServicios] = useState([]);
  const [filteredServicios, setFilteredServicios] = useState([]);
  const [search, setSearch] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [selectedServicio, setSelectedServicio] = useState(null);
  const [errors, setErrors] = useState({});
  const [servicioAEliminar, setServicioAEliminar] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [toast, setToast] = useState({ show: false, message: '', variant: 'success' });

  const normalizeText = (text) => {
    return text
      ?.toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, ""); // quita acentos
  };

  const mostrarToast = (variant, message) => {
    setToast({ show: true, variant, message });

    setTimeout(() => {
      setToast({ ...toast, show: false });
    }, 3000);
  };

  useEffect(() => {
    api.get('/servicios')
      .then(res => {
        setServicios(res.data);
        setFilteredServicios(res.data);
      })
      .catch(err => {
        console.error('error al obtener servicios', err);
      });
  }, []);

  useEffect(() => {
    const result = servicios.filter(item =>
      (item.Servicio && normalizeText(item.Servicio).includes(normalizeText(search))) ||
      (item.Sigla && normalizeText(item.Sigla).includes(normalizeText(search))) ||
      (item.Minimo && normalizeText(item.Minimo).includes(normalizeText(search))) ||
      (item.Maximo && normalizeText(item.Maximo).includes(normalizeText(search)))
    );
    setFilteredServicios(result);
  }, [search, servicios]);

  const handleEditClick = (servicio) => {
    setIsEditing(true);
    setErrors({});
    setSelectedServicio({ ...servicio }); // clona el objeto
    setShowModal(true);
  };

  const handleAddClick = () => {
    if(servicios.length >= maxServicios ){
      mostrarToast('info', 'No es posible crear un nuevo servicio. Por favor comuníquese con soporte al correo siteturnos@sitesas.co');
    }else{
      setIsEditing(false);
      setSelectedServicio({
        Servicio: '',
        Sigla: '',
        Minimo: '',
        Maximo: '',
        visible: 1,
        IdSala: idSala,
        reservado: (userRole === 'admin' ? 1 : 0),
      });
      setErrors({});
      setShowModal(true);
    } 
  };

  const handleInputChange = (e) => {
    setSelectedServicio({
      ...selectedServicio,
      [e.target.name]: e.target.value
    });
  };

  const validate = () => {
    const newErrors = {};

    if (!selectedServicio.Servicio?.trim()) newErrors.Servicio = "Campo requerido";
    if (!selectedServicio.Sigla?.trim()) {
      newErrors.Sigla = "Campo requerido";
    } else if (selectedServicio.Sigla.trim().length !== 2) {
      newErrors.Sigla = "Debe tener exactamente 2 caracteres";
    } else {
      const mismaSiglaYaExiste = servicios.some(ser =>
        ser.Sigla?.trim().toUpperCase() === selectedServicio.Sigla?.trim().toUpperCase() &&
        ser.idServicio !== selectedServicio.idServicio // permite que conserve su propia sigla al editar
      );

      if (mismaSiglaYaExiste) {
        newErrors.Sigla = 'Existe un servicio con esta sigla.';
      }
    }

    if (!selectedServicio.Minimo?.trim()) newErrors.Minimo = "Campo requerido";
    else if (isNaN(selectedServicio.Minimo)) newErrors.Minimo = "Debe ser numérico";

    if (!selectedServicio.Maximo?.trim()) newErrors.Maximo = "Campo requerido";
    else if (isNaN(selectedServicio.Maximo)) newErrors.Maximo = "Debe ser numérico";

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleUpdate = () => {
    if (!validate()) return;

    setIsSaving(true);
    api.put(`/servicios/${selectedServicio.idServicio}`, selectedServicio)
      .then((res) => {
        const updatedList = servicios.map(item =>
          item.idServicio === selectedServicio.idServicio ? res.data.data : item
        );
        setServicios(updatedList);
        setFilteredServicios(updatedList);
        setShowModal(false);
        mostrarToast('success', 'Servicio actualizado correctamente');
      })
      .catch((err) => {
        console.error('Error al actualizar:', err);
        mostrarToast('danger', 'Error al actualizar el servicio');
      })
      .finally(() => {
        setIsSaving(false);
      });
  };

  const handleCreate = () => {
    if (!validate()) return;

    setIsSaving(true);
    api.post('/servicios', selectedServicio)
      .then((res) => {
        const nuevo = res.data.data;
        const nuevaLista = [...servicios, nuevo];
        setServicios(nuevaLista);
        setFilteredServicios(nuevaLista);
        setShowModal(false);
        mostrarToast('success', 'Servicio creado correctamente');
        

      })
      .catch((err) => {
        console.error('Error al crear:', err);
        mostrarToast('danger', 'Error al crear el servicio');
      })
      .finally(() => {
        setIsSaving(false);
      });
  };  

  const handleDelete = (row) => {
    setServicioAEliminar(row);
    setShowDeleteModal(true);
  };

  const confirmarEliminacion = () => {
    setIsDeleting(true);
    api.delete(`/servicios/${servicioAEliminar.idServicio}`)
      .then(() => {
        const listaNueva = servicios.filter(ser => ser.idServicio !== servicioAEliminar.idServicio);
        setServicios(listaNueva);
        mostrarToast('success', 'Servicio eliminado correctamente.');
      })
      .catch(() => mostrarToast('danger', 'Error al eliminar el servicio.'))
      .finally(() => {
        setIsDeleting(false);
      });
    setShowDeleteModal(false);
  };
  
  const columns = useMemo(() => {
    const baseColumns = [
      { name: 'Servicio', selector: row => row.Servicio, sortable: true },
      { name: 'Sigla', selector: row => row.Sigla, sortable: true },
      { name: 'Mínimo', selector: row => row.Minimo, sortable: true },
      { name: 'Máximo', selector: row => row.Maximo, sortable: true },
      { name: 'Visible', 
        selector: row => row.visible,
        cell: row => (
          <Form.Check
            type="switch"
            id={`switch-${row.idServicio}`}
            checked={row.visible === 1}
            disabled
            readOnly
          />
        ),
        ignoreRowClick: true,
        button: true,
      },
      {
        name: 'Pantalla(s) asignada(s)',
        cell: row => {
          const total = row.pantallas ? row.pantallas.length : 0;

          return (
            <span
              className={total === 0 ? 'text-danger fw-bold' : 'text-success fw-bold'}
            >
              {total}
            </span>
          );
        },
        sortable: false,
        wrap: true,
      }
    ];

    if(userRole !== 'consulta') {
      baseColumns.push({
        name: 'Opciones',
        cell: row => (
          <div className="d-flex gap-2">
            {userRole !== 'consulta' && (
              <Button variant="outline-primary" size="sm" onClick={() => handleEditClick(row)}>
                <Pencil />
              </Button>
            )}
            {userRole === 'admin' && (
              <Button
                variant="outline-danger"
                size="sm"
                onClick={() => handleDelete(row)}
              >
                <Trash />
              </Button>
            )}
          </div>
          ),
        ignoreRowClick: true,
        button: true,
      })
    }

    return baseColumns;
  }, [userRole]);

  return (
    <div className="mt-4">
      <DataTable
        title="Listado de Servicios"
        columns={columns}
        data={filteredServicios}
        pagination
        highlightOnHover
        responsive
        striped
        subHeader
        subHeaderComponent={
          <div className="d-flex justify-content-between w-100">
            {userRole !== 'consulta' &&  (
              <Button variant="outline-success" size="sm" onClick={handleAddClick}>
                Nuevo <Plus />
              </Button>
            )}
            <input
              type="text"
              className="form-control w-25"
              placeholder="Buscar..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        }
      />

      {/* Modal de Edición */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{isEditing ? 'Editar Servicio' : 'Nuevo Servicio'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {!isEditing && (
            <>
              <Alert variant="info">
                <strong>Nota:</strong> los servicios visibles se utilizan para asignar turnos mediante la pantalla táctil (Recepción). 
                Los servicios no visibles funcionan como colas internas y no se muestran en la pantalla táctil.
              </Alert>
              <Alert variant="info">
                <strong>Importante:</strong><br />
                Recuerde asignar este servicio a una o más <strong>pantallas</strong>.
                Si no lo hace, <strong>los turnos de este servicio no se visualizarán</strong>.
              </Alert>
            </>
            
          )}
          {selectedServicio && (
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>Servicio</Form.Label>
                <Form.Control
                  type="text"
                  name="Servicio"
                  value={selectedServicio.Servicio}
                  onChange={handleInputChange}
                  isInvalid={!!errors.Servicio}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.Servicio}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Sigla</Form.Label>
                <Form.Control
                  type="text"
                  name="Sigla"
                  value={selectedServicio.Sigla}
                  onChange={(e) =>
                    setSelectedServicio({
                      ...selectedServicio,
                      Sigla: e.target.value.toUpperCase()
                    })
                  }
                  isInvalid={!!errors.Sigla}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.Sigla}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Mínimo</Form.Label>
                <Form.Control
                  type="number"
                  name="Minimo"
                  value={selectedServicio.Minimo}
                  onChange={handleInputChange}
                  isInvalid={!!errors.Minimo}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.Minimo}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Máximo</Form.Label>
                <Form.Control
                  type="number"
                  name="Maximo"
                  value={selectedServicio.Maximo}
                  onChange={handleInputChange}
                  isInvalid={!!errors.Maximo}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.Maximo}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Check
                  type="switch"
                  label="Visible"
                  name="visible"
                  checked={selectedServicio.visible === 1}
                  onChange={(e) =>
                    setSelectedServicio({
                      ...selectedServicio,
                      visible: e.target.checked ? 1 : 0,
                    })
                  }
                />
              </Form.Group>
              {userRole === 'admin' && (
                <Form.Group className="mb-3">
                  <Form.Check
                    type="switch"
                    label="Reservado"
                    name="reservado"
                    checked={isEditing ? selectedServicio.idServicio >= 50 : selectedServicio.reservado}
                    onChange={(e) =>
                      setSelectedServicio({
                        ...selectedServicio,
                        reservado: e.target.checked ? 1 : 0,
                      })
                    }
                  />
                </Form.Group>
              )}
            </Form>
          )}
          {isEditing && (
            <Alert variant="secondary">
              <strong>Pantallas asignadas:</strong><br />
              {selectedServicio.pantallas?.length > 0
                ? selectedServicio.pantallas.map(p => p.nombre).join(', ')
                : 'Este servicio no está asignado a ninguna pantalla.'}
            </Alert>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancelar
          </Button>
          <Button
            variant="primary"
            onClick={isEditing ? handleUpdate : handleCreate}
            disabled={isSaving}
          >
            {isSaving
              ? (isEditing ? 'Guardando...' : 'Creando...')
              : (isEditing ? 'Guardar Cambios' : 'Crear Servicio')}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal de Confirmación para eliminar */}
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirmar eliminación</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          ¿Está seguro de que desea eliminar el servicio <strong>{servicioAEliminar?.Servicio}</strong>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
            Cancelar
          </Button>
          <Button variant="danger"
            onClick={confirmarEliminacion}
            disabled={isDeleting}
          >
            {isDeleting ? 'Eliminando...' : 'Eliminar'}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Mensaje Toast */}
      <ToastContainer position="top-end" className="p-3">
        <Toast
          bg={toast.variant}
          onClose={() => setToast({ ...toast, show: false })}
          show={toast.show}
          delay={3000}
          autohide
        >
          <Toast.Body className="text-white">{toast.message}</Toast.Body>
        </Toast>
      </ToastContainer>
    </div>
  );
};

export default Servicios;
